import { api } from "./api";

export const RESULT_TYPES = [
  ["time", "Tiempo"], ["distance", "Distancia"], ["height", "Altura"], ["reps", "Repeticiones"], ["load", "Carga"],
  ["score", "Puntuación con escala"], ["qualitative", "Cualitativo / valoración técnica"], ["video", "Vídeo para revisión"], ["combined", "Combinado (medición + valoración técnica)"],
];
export const UNITS = { time: ["s", "ms"], distance: ["cm", "m"], height: ["cm"], reps: ["reps"], load: ["kg"] };
export const MEASURE_TYPES = RESULT_TYPES.filter(([k]) => ["time", "distance", "height", "reps", "load", "score"].includes(k));
export const AGG = [["best", "Mejor intento"], ["mean", "Media de los intentos"], ["median", "Mediana"], ["last", "Último intento"], ["worst", "Peor intento"]];
export const VIDEO_REQ = [["none", "No necesario"], ["optional", "Opcional"], ["required", "Obligatorio"]];
export const STATE = {
  pending: ["Pendiente", "#a3a3a3"], overdue: ["Pendiente · fecha pasada", "#facc15"], needs_review: ["Necesita revisión", "#60a5fa"],
  completed: ["Completado", "#4ade80"], needs_setup: ["Ficha incompleta", "#f97316"], retired: ["Retirado", "#737373"],
  in_progress: ["En curso", "#fbbf24"], awaiting_result: ["Pendiente de resultado", "#fb923c"], repeat_requested: ["Repetición solicitada", "#f87171"],
};
export const PLAYER_STATE = { ...STATE, overdue: ["Pendiente", "#facc15"], needs_review: ["Pendiente de revisión", "#60a5fa"], needs_setup: ["En preparación", "#737373"] };
export const RES_STATUS = { submitted: "Enviado · pendiente de revisión", approved: "Validado", rejected: "Repetir / corregir" };
export const localToday = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`; };
export const daysUntil = (iso) => Math.round((new Date(`${iso}T00:00:00`) - new Date(`${localToday()}T00:00:00`)) / 86400000);
export const label = (list, k) => (list.find(([x]) => x === k) || [null, k || "—"])[1];
export const measureOf = (t) => (t?.result_type === "combined" ? t.measure_type : t?.result_type);
export const isNumeric = (m) => ["time", "distance", "height", "reps", "load", "score"].includes(m);
export const unitText = (t) => (measureOf(t) === "score" ? `puntos (${t.scale_min}–${t.scale_max})` : t?.unit || "");

export const aggregate = (vals, method, dir) => {
  if (!vals.length) return null;
  if (method === "mean") return Math.round((vals.reduce((a, b) => a + b, 0) / vals.length) * 1000) / 1000;
  if (method === "median") { const s = [...vals].sort((a, b) => a - b); const m = Math.floor(s.length / 2); return s.length % 2 ? s[m] : (s[m - 1] + s[m]) / 2; }
  if (method === "last") return vals[vals.length - 1];
  if (vals.length === 1) return vals[0];
  if (!dir) return null;
  const better = dir === "higher" ? Math.max : Math.min;
  const worse = dir === "higher" ? Math.min : Math.max;
  return method === "worst" ? worse(...vals) : better(...vals);
};

export async function uploadTestFile(file, purpose, onProgress) {
  const { data } = await api.post("/test-files/init", { filename: file.name, content_type: file.type || "application/octet-stream", size: file.size, purpose });
  for (let off = 0; off < file.size; off += data.chunk_size) {
    await api.put(`/test-files/${data.id}/chunk`, file.slice(off, off + data.chunk_size), {
      headers: { "Content-Type": "application/octet-stream" },
      onUploadProgress: (e) => onProgress && onProgress(Math.min(99, Math.round(((off + e.loaded) / file.size) * 100))),
    });
    onProgress && onProgress(Math.min(100, Math.round(((off + data.chunk_size) / file.size) * 100)));
  }
  onProgress && onProgress(100);
  const r = await api.post(`/test-files/${data.id}/complete`);
  return r.data;
}
